import Resource from './resource';
import request from "../utils/request";

class DataCards extends Resource {
    constructor() {
        super('data_cards');
    }

    store(resource) {
        return request({
            url: `/group_cards/store`,
            method: 'post',
            data: resource
        })
    }

    list(resource) {
        return request({
            url: `/group_cards/list`,
            method: 'POST',
            data: resource
        })
    }

    delete(id) {
        return request({
            url: `/group_cards/delete/${id}`,
            method: 'delete',
        })
    }

    show(id) {
        return request({
            url: `/group_cards/show/${id}`,
            method: 'get',
        })
    }

    update(id, data) {
        return request({
            url: `/group_cards/update/${id}`,
            method: 'post',
            data: data
        })
    }
    usersGroupCards(id, query) {
      return request({
          url: `/group_cards/usersGroupCards/${id}`,
          method: 'post',
          data: query
        })
    }
    subTopicsCards(id, query) {
      return request({
          url: `/group_cards/SupTopicsGroupCards/${id}`,
          method: 'post',
          data: query
        })
    }
    lookups(resource) {
        return request({
            url: `/group_cards/lookups`,
            method: 'post',
            data: resource || {}
        })
    }

    institutionInstructors(resource, groupCardId) {
        const suffix = groupCardId ? `/${groupCardId}` : '';
        return request({
            url: `/group_cards/institutionInstructors${suffix}`,
            method: 'post',
            data: resource || {}
        })
    }

    addUsers(id, payload) {
        const data = Array.isArray(payload)
            ? { users: payload }
            : {
                users: payload && payload.users ? payload.users : [],
                ...(payload && payload.organization_id ? { organization_id: payload.organization_id } : {})
            };
        return request({
            url: `/group_cards/addUsersToGroupCard/${id}`,
            method: 'post',
            data
        })
    }

    removeMember(id, userId) {
        return request({
            url: `/group_cards/removeUsersFromGroupCard/${id}`,
            method: 'post',
            data: {
                users: [userId]
            }
        })
    }

    unAssignMe(groupId) {
        return request({
            url: `/group_cards/unAssignMe/${groupId}`,
            method: 'post'
        })
    }

    submitAnswers(payload) {
        return request({
            url: `/group_cards/answers`,
            method: 'post',
            data: payload
        })
    }

    updateMemberStatus(groupId, userId, status) {
        return request({
            url: `/group_cards/update-user-status/${groupId}`,
            method: 'post',
            data: { user_id: userId, status: status }
        })
    }
}

export { DataCards as default };
